"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SliderContainer = exports.SliderSwitch = void 0;

var _rgb = _interopRequireDefault(require("polished/lib/color/rgb"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _designTokens = require("@decisiv/design-tokens");

var _dynamicModifiers = require("../../utils/dynamicModifiers");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwitch = _styledComponents.default.div.withConfig({
  displayName: "Slider__SliderSwitch",
  componentId: "egedid-0"
})(["background-color:", ";border-radius:50%;position:absolute;transition:left 200ms cubic-bezier(0.39,0.575,0.565,1);", ";", ";"], (0, _rgb.default)(_designTokens.color.base.snowWhite), (0, _dynamicModifiers.applyDynamicModifiers)('position', function (_ref) {
  var position = _ref.position,
      size = _ref.size;

  if (position === 'left') {
    return (0, _styledComponents.css)(["left:", "px;"], _designTokens.spacing.base * 0.2);
  }
  /* Must equal the width of the SliderBar minus the width of the SliderSwitch */

  /* Must use the `left` position to maintain the animation of "sliding" */


  return size === 'small' ? (0, _styledComponents.css)(["left:", "px;"], _designTokens.spacing.base * 1.7) : (0, _styledComponents.css)(["left:", "px;"], _designTokens.spacing.base * 2.1);
}), (0, _dynamicModifiers.applyDynamicModifiers)('size', function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? (0, _styledComponents.css)(["height:", "px;width:", "px;"], _designTokens.spacing.base * 1.2, _designTokens.spacing.base * 1.2) : (0, _styledComponents.css)(["height:", "px;width:", "px;"], _designTokens.spacing.base * 1.6, _designTokens.spacing.base * 1.6);
}));

exports.SliderSwitch = SliderSwitch;

var SliderBar = _styledComponents.default.div.withConfig({
  displayName: "Slider__SliderBar",
  componentId: "egedid-1"
})(["align-items:center;background-color:rgb(color.base.quarterMoon)};border-radius:1px;display:flex;height:2px;position:relative;", ";"], (0, _dynamicModifiers.applyDynamicModifiers)('size', function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? (0, _styledComponents.css)(["width:", "px;"], _designTokens.spacing.base * 3.3) : (0, _styledComponents.css)(["width:", "px;"], _designTokens.spacing.base * 4.1);
}));

var SliderContainer = _styledComponents.default.div.withConfig({
  displayName: "Slider__SliderContainer",
  componentId: "egedid-2"
})(["align-items:center;display:inline-flex;margin:0 ", "px;", ";", ";"], _designTokens.spacing.base, (0, _dynamicModifiers.applyDynamicModifiers)('position', function (_ref4) {
  var position = _ref4.position;
  var fillColor = (0, _rgb.default)(position === 'left' ? _designTokens.color.base.alaskanHusky : _designTokens.color.status.success.medium);
  return (0, _styledComponents.css)(["background:", ";border:thin solid ", ";}"], fillColor, fillColor);
}), (0, _dynamicModifiers.applyDynamicModifiers)('size', function (_ref5) {
  var size = _ref5.size;
  return size === 'small' ? (0, _styledComponents.css)(["height:", "px;width:", "px;border-radius:", "px;"], _designTokens.spacing.base * 1.8, _designTokens.spacing.base * 3.3, _designTokens.spacing.base * 0.9) : (0, _styledComponents.css)(["border-radius:", "px;height:", "px;width:", "px;"], _designTokens.spacing.base + 1, _designTokens.spacing.base * 2 + 2, _designTokens.spacing.base * 4.1);
}));

exports.SliderContainer = SliderContainer;

function Slider(_ref6) {
  var position = _ref6.position,
      size = _ref6.size;
  return _react.default.createElement(SliderContainer, {
    size: size,
    position: position
  }, _react.default.createElement(SliderBar, {
    size: size
  }, _react.default.createElement(SliderSwitch, {
    position: position,
    size: size
  })));
}

var _default = Slider;
exports.default = _default;